import { Currency } from "./currency.type";

export enum PriceChangeRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  SUPERSEDED = "superseded",
}

export interface MoneyPair {
  USD: number;
  UZS: number;
}

export interface IPriceChangeRequest {
  _id: string;
  produceId: string;
  produceName: string;
  categoryId?: string | null;
  categoryName?: string;

  reason: string;
  triggeredByMaterialId?: string | null;
  triggeredByMaterialName?: string;

  oldCost: MoneyPair;
  newCost: MoneyPair;
  costIncomplete: boolean;
  missingMaterials?: string[];

  /** Прайс — только справочно: умный прайс его не меняет. */
  currentPrice: MoneyPair;
  currentLowTradePrice: MoneyPair;
  proposedPrice: MoneyPair;
  proposedLowTradePrice: MoneyPair;
  priceChanged: boolean;
  lowTradePriceChanged: boolean;

  /**
   * @deprecated Умный прайс считает только мин. цену. Поля остаются у старых записей.
   */
  targetProfitPercent?: number;
  /** @deprecated */
  maxDiscountPercent?: number;
  /** @deprecated */
  saleLimitPercent?: number;
  /** Наценка на себестоимость, применённая к мин. цене. */
  minProfitPercent?: number;
  currency: Currency;
  exchangeRate: number;

  status: PriceChangeRequestStatus;
  approvedAt?: string;
  approvalNotes?: string;
  rejectedAt?: string;
  rejectionReason?: string;

  createdAt: string;
  updatedAt: string;
}
